import React from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';

import { enhancedConnect } from 'utils/lowCodeHelpers';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

const _DarkActionBlock: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <section className={cx('wrapper')}>
      <div className={cx('container')}>{children}</div>
    </section>
  );
};

export const DarkActionBlock = enhancedConnect({
  children: PropTypes.node,
})(_DarkActionBlock);
